export const sizeItemOnPage = 6;
export const FAQTitles = [
    { field: "title", key: "title" },
    { field: "description", key: "description" },
];
